(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  function activateTabFromHash() {
    const hash = window.location.hash;
    if (!hash) return;

    const tabLink = document.querySelector('.m-tab-header[href="' + hash + '"]');
    if (tabLink) {
      tabLink.click();
    }
  }

  document.addEventListener("DOMContentLoaded", activateTabFromHash);

  window.addEventListener("hashchange", function() {
    location.reload(); 
  });

  } catch(e) { console.error(e); }
})();
})();
